interface ApiResult<T> {
  data?: T;
  error?: unknown;
}

interface ApiError {
  message?: string;
  response?: { status?: number; data?: { message?: string } | null };
}

/**
 * Turns the legacy `{ data, error }` result of `UserAPI` into react-query semantics.
 *
 * @returns The result's data.
 * @throws The result's error (the original axios error), so callers can read its status and message.
 */
export const unwrapApiResult = <T>({ data, error }: ApiResult<T>): T => {
  if (error) throw error;
  return data as T;
};

/**
 * Best message for a failed request: the server's message, then the error's own, then the fallback.
 */
export const getApiErrorMessage = (error: unknown, fallback: string) => {
  const { message, response } = (error ?? {}) as ApiError;
  return response?.data?.message || message || fallback;
};

/**
 * Whether a failed request was rejected with HTTP 409 (the address belongs to another account).
 */
export const isConflict = (error: unknown) => (error as ApiError)?.response?.status === 409;
